module.exports = __webpack_public_path__ + "images/leaseplan_small1ca1ff06b3e4506e0dfe38a26b127f4c.png";